import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 18 18"
    {...props}
  >
    <defs>
      <radialGradient
        id="b"
        cx="11.317%"
        cy="2.521%"
        r="124.298%"
        fx="11.317%"
        fy="2.521%"
      >
        <stop offset="0%" stopColor="#EEF6FF" />
        <stop offset="100%" stopColor="#DCE6FB" />
      </radialGradient>
      <filter
        id="d"
        width="111.1%"
        height="111.1%"
        x="-5.6%"
        y="-5.6%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation={0.5}
        />
        <feOffset dy={1} in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2={-1}
          k3={1}
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.0530553431 0"
        />
      </filter>
      <rect id="a" width={18} height={18} x={0} y={0} rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <use xlinkHref="#a" fill="url(#b)" />
      <use xlinkHref="#a" fill="#000" filter="url(#d)" />
      <path
        fill="#2C6AFF"
        d="m7.438 3.167-1.901.887 1.018 2.185 1.734.809.48-1.028zm1.794 8.813 1.33 2.854 1.903-.888-1.019-2.183-1.735-.81z"
      />
      <path
        fill="#FFBE00"
        d="m11.752 6.56-.001.001-1.926.896-.253.119-1.779.829-.503.236-.045.02-1.194.558-.045.019-2.838 1.324.886 1.903 2.195-1.024.001-.001 1.926-.897.253-.118.211-.098.331-.156 1.238-.577.249-.116.255-.118 1.237-.579.046-.02 2.838-1.324-.887-1.901z"
      />
      <path
        fill="#2C6AFF"
        d="m3.167 7.438 2.853 1.33 1.091-.508.254-.118.552-.257.396-.187.19-.088-4.448-2.073zm7.723 2.303-.254.119-.554.257-.584.273.074.034.253.118 4.122 1.922.887-1.902-2.853-1.33z"
      />
      <path
        fill="#FF4F60"
        d="M10.563 3.167 9.219 6.05 8.67 7.225l.33.154.648-.303 1.797-.838 1.02-2.184zm-1.956 7.638-.253.118-1.799.84-1.02 2.184 1.903.886 1.345-2.882.153-.332.395-.844-.33-.153z"
      />
    </g>
  </svg>
);
const Memo = memo(Icon);
export default Memo;
